export default {
    app_name: process.env.VUE_APP_NAME,
    api_url: process.env.VUE_APP_API_URL,
    api_key: process.env.VUE_APP_API_KEY,
    item_url: process.env.VUE_APP_ITEM_URL,
    author_github_link: process.env.VUE_APP_AUTHOR_GITHUB_LINK,
    project_github_link: process.env.VUE_APP_PROJECT_GITHUB_LINK
};

/**
 * Item-icon URL. Icons are self-hosted at /items/{id}.webp (Vercel public/),
 * served same-origin.
 *
 * Intentionally HARDCODED — not read from VUE_APP_ITEM_URL — because a stale
 * VUE_APP_ITEM_URL set in the Vercel project dashboard was overriding
 * .env.production at build time and pointing icons back at the (now-403)
 * Divine Pride CDN. Hardcoding makes the build immune to that.
 */
export function itemIconUrl(id) {
    return `/items/${id}.webp`;
}
